export const SET_ITEMS_CREATION_FORM_IS_FOCUSED = 'SET_ITEMS_CREATION_FORM_IS_FOCUSED'
export const SET_ITEMS_CREATION_FORM_IS_EMPTY = 'SET_ITEMS_CREATION_FORM_IS_EMPTY'
